import React from 'react';
import { MdFindReplace } from 'react-icons/md';

import { Roles } from 'components/RoleGate/types';
import RoleButton from 'components/RoleButton';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { BULK_EDIT_MODAL_QUERY_STRING_PARAM } from 'components/VirtualizedTable/constants';

interface Props {
    requiredRoles: Roles[];
}

export const VirtualizedTableBulkEditButtonComponent = (
    props: Props
): React.ReactElement => {
    const { requiredRoles } = props;
    return (
        <RoleButton
            requiredRoles={requiredRoles}
            params={{
                [BULK_EDIT_MODAL_QUERY_STRING_PARAM]: true
            }}
            buttonProps={{
                icon: true,
                color: 'black',
                basic: true,
                style: {
                    marginRight: 0,
                    marginLeft: 8
                }
            }}
        >
            <ButtonIconWrapper>
                <MdFindReplace
                    style={{
                        fontSize: 20
                    }}
                />
            </ButtonIconWrapper>
            Replace
        </RoleButton>
    );
};

export default VirtualizedTableBulkEditButtonComponent;
